// extracted by mini-css-extract-plugin
module.exports = {"heading":"app_heading__1krD4"};